<template>
  <div class="video-container">
    <div class="video">
      <v-container class="justify-center fill-height" tag="section">
        <v-row justify="center">
          <v-col cols="12" sm="8" md="6">
            <!-- 키방식-->
            <v-card
              v-if="content && content.who == 'key'"
              class="elevation-4 pa-3"
            >
              <v-card-text>
                <div class="pb-4 font-weight-black">{{ content.title }}</div>
                <v-form ref="form">
                  <v-text-field
                    v-model="key"
                    label="Key"
                    color="blue"
                    class="mt-2"
                    required
                    outlined
                    dense
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                    @keyup.enter="keyEnterHandler"
                    @keypress.enter.prevent
                  ></v-text-field>
                </v-form>
                <v-btn
                  :disabled="!valid"
                  color="blue"
                  block
                  small
                  class="mr-4 white--text"
                  @click="keyEnterHandler"
                  >Enter</v-btn
                >
              </v-card-text>
            </v-card>
            <!-- 사인인 -->
            <v-card
              v-if="
                (content && content.who == 'me') ||
                  (content && content.who == 'allowed')
              "
              class="elevation-4 pa-3 pt-0"
            >
              <v-card-text class="pa-1">
                <div class="pt-3 font-weight-black">{{ content.title }}</div>
                <v-form ref="form" class="">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    color="blue"
                    class="mt-4"
                    required
                    dense
                    outlined
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    :counter="10"
                    :rules="passwordRules"
                    label="Password"
                    color="blue"
                    class=""
                    required
                    dense
                    outlined
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                    @keypress.enter="delay"
                    @keypress.enter.prevent
                  ></v-text-field>
                </v-form>
                <div class="mb-4 mb-sm-0">
                  <div class="d-flex">
                    <v-btn
                      small
                      text
                      @click.stop="openForgotDialog()"
                      class="text-caption pl-0"
                      >Forgot Password ?</v-btn
                    >

                    <v-btn
                      :disabled="!valid"
                      color="blue"
                      small
                      class="ml-auto white--text"
                      @click="signInEnterHandler"
                      >Sign In</v-btn
                    >
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <!-- 비밀번호 찾기 모달창 -->
        <v-dialog v-model="forgotDialog" max-width="400">
          <v-card>
            <div class="d-flex pa-2 align-center primary">
              <v-card-title class="headline white--text"
                >Forgot Password
              </v-card-title>
              <div class="ml-auto">
                <v-btn icon color="error" @click="closeForgotDialog()">
                  <v-icon small class="white--text">mdi-window-close</v-icon>
                </v-btn>
              </div>
            </div>

            <v-card-text class="mt-7">
              <v-card-text class="pa-0"
                >No Worries. Just tell us the email address you registered with
                Onseminar.</v-card-text
              >
              <v-form ref="form2" v-model="valid" lazy-validation>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="forgotEmail"
                      :rules="emailRules"
                      label="E-mail"
                      prepend-icon="mdi-email"
                      color="primary"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="d-flex justify-end">
                    <vue-recaptcha
                      sitekey="6LecSmUaAAAAAMQQ4dXr1LfLIKHx4qLgSf45rtVG"
                      :loadRecaptchaScript="true"
                    ></vue-recaptcha
                  ></v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-2 white--text" @click="send()"
                >Send</v-btn
              >
              <v-btn
                color="grey"
                class="text-capitalize"
                dark
                @click="closeForgotDialog()"
                >Cancel</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
  </div>
</template>

<script>
// import jwtDecode from "jwt-decode";
// import Auth from "@/plugins/aws-amplify";
import VueRecaptcha from "vue-recaptcha";
import { mapState } from "vuex";
import { Base64 } from "js-base64";
const _up = process.env.VUE_APP_KEY_MASS_UP;
const _down = process.env.VUE_APP_KEY_MASS_DOWN;

export default {
  name: "Gate",
  data: () => ({
    id: "",
    absolute: true,
    overlay: false,
    idToken: "",
    idTokenDecoded: "",
    valid: true,
    key: "",
    email: "",
    password: "",
    show1: false,
    forgotEmail: "",
    forgotDialog: false,
    passwordRules: [
      v => !!v || "Password is required",
      v => (v && v.length <= 14) || "Password must be less than 14 characters"
    ],
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ]
  }),
  components: { VueRecaptcha },
  computed: {
    ...mapState(["content", "gatePass"])
  },
  mounted() {
    console.log("[beforeCreate] init");
    this.init();
  },
  methods: {
    openForgotDialog() {
      this.forgotDialog = true;
      if (this.email) {
        this.forgotEmail = this.email;
      }
    },
    init() {
      // this.id = this.content.id;
      this.id = this.$route.params.id;
      console.log("[Gate] id", this.id, this.content);
      if (!this.content) {
        this.$router.push({
          name: "Video",
          params: { id: this.id }
        });
      }
    },
    async send() {
      this.$refs.form2.validate();
      // eslint-disable-next-line no-undef
      var v = grecaptcha.getResponse();
      if (v.length == 0) {
        this.$notify({
          type: "warning",
          title: "Please Check [I'm not a robot]",
          duration: 5000,
          closeOnClick: true
        });

        return false;
      }

      const path = "/auth/forgot-password?email=" + this.forgotEmail;
      try {
        const data = await this.$axiosAuth.get(path);
        console.log(data);
        if (data && data.status == 200) {
          this.$notify({
            type: "success",
            title: "Forgot Password",
            text:
              "An email has been sent to change the password. Please check your email.",
            duration: 5000,
            closeOnClick: true
          });
        }
      } catch (e) {
        const msg = e.response.data.message;
        this.$notify({
          type: "error",
          title: "Forgot Password",
          text: msg,
          duration: 5000,
          closeOnClick: true
        });
      }
      this.closeForgotDialog();
    },
    closeForgotDialog() {
      this.$refs.form2.reset();
      this.$refs.form2.resetValidation();
      this.forgotDialog = false;
    },
    async keyEnterHandler() {
      const KeyIn = Base64.encode(_up + this.key + _down);
      console.log(
        this.key,
        this.content.key,
        KeyIn == this.content.key,
        this.id,
        this.content.id
      );
      if (KeyIn == this.content.key) {
        this.$store.commit("SET_KEY_PASS", true);
        this.$router
          .push({ name: "Video", params: { id: this.content.id } })
          .catch(() => {});
      } else {
        this.$notify({
          type: "error",
          title: "Invalid Key",
          text: "Please check your key",
          duration: 5000,
          closeOnClick: true
        });
      }
    },
    async openEnterHandler() {
      const url = this.id;
      this.$router.push(url).catch(() => {});
    },
    async signInEnterHandler() {
      if (!this.$refs.form.validate()) return;
      const signInfo = {
        email: this.email,
        password: this.password,
        redirect: this.id
      };
      await this.$store.dispatch("signIn", signInfo);
      if (this && this.$refs && this.$refs.form) {
        this.$refs.form.reset();
      }
    }
  }
};
</script>
<style>
.video-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  border: 1px;
}
.video {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>
